import { render } from "./famousCourseAdd.vue?vue&type=template&id=c5140c06&scoped=true"
import script from "./famousCourseAdd.vue?vue&type=script&lang=js"
export * from "./famousCourseAdd.vue?vue&type=script&lang=js"

import "./famousCourseAdd.vue?vue&type=style&index=0&id=c5140c06&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5140c06"]])

export default __exports__